var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.446154,
    y: 0.446154,
    width: 173.108,
    height: 173.108,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.446154,
    y: 0.446154,
    width: 173.108,
    height: 173.108,
    stroke: "black",
    strokeWidth: 0.892308
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 154,
    height: 154,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_348_13465",
    transform: "scale(0.00333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_348_13465",
    width: 300,
    height: 300,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/Qr.67494034813ba940f940603a7ee535ff.svg";
export { ForwardRef as ReactComponent };